import Utils from "../../../utils/node.utils"
import React, { Component } from "react"
import Product from "./Product"
import { Link } from "gatsby"

const defaultScrollSize = 12

export default class ProductList extends Component {
  state = {
    page: 0,
    numPage: 0,
    productLen: 0,
  }

  getPage = numPage => {
    const { page } = this.state
    return numPage <= page ? 0 : page
  }

  getNumPage = () => {
    const { products } = this.props
    return Math.ceil(products.length / defaultScrollSize)
  }

  getPageFromSearch(numPage) {
    const search = this.getSearch()

    if (!search) {
      return 0
    }

    const params = Utils.ParseURLQuery(search)

    if (params.page) {
      const parsed = parseInt(params.page)
      if (!isNaN(parsed) && parsed > 0 && numPage > parsed) {
        return parsed
      }
    }

    return 0
  }

  getSearch() {
    if (typeof window !== "undefined") {
      return window.location.search
    }
    return this.props.search
  }

  componentDidMount() {
    const { products } = this.props
    const numPage = this.getNumPage()
    const page = this.getPageFromSearch(numPage)

    this.setState({
      page: page,
      numPage: numPage,
      productLen: products.length,
    })
  }

  goToPage = (e, page) => {
    if (page < 0) {
      e.preventDefault()
      return
    }

    this.setState({
      page: page,
    })
  }

  componentDidUpdate() {
    const { products } = this.props
    const { productLen, page, numPage } = this.state

    if (products.length !== productLen) {
      this.setState({
        page: 0,
        numPage: this.getNumPage(),
        productLen: products.length,
      })
      return
    }

    const searchPage = this.getPageFromSearch(numPage)

    if (searchPage != page) {
      this.setState({
        page: searchPage,
      })
    }
  }

  getProducts = () => {
    const {
      products,
      breadCrumb,
      language,
      contentMap,
      commonContentMap,
    } = this.props
    const { page } = this.state
    const startIndex = page * defaultScrollSize
    let returnProducts = []

    for (
      let i = startIndex;
      i < Math.min(products.length, startIndex + defaultScrollSize);
      i++
    ) {
      const product = products[i].node.item

      returnProducts.push(
        <Product
          key={product.id}
          product={product}
          breadCrumb={breadCrumb}
          language={language}
          contentMap={contentMap}
          commonContentMap={commonContentMap}
        />
      )
    }

    return returnProducts
  }

  getPrevStyle(page) {
    let style =
      "d-none d-md-block col-md-1 btn btn-white text-lg text-center order-0 order-md-0"

    if (page === 0) {
      style += " disabled"
    }

    return style
  }

  getNextStyle(page, numPage) {
    let style =
      "d-none d-md-block col-md-1 btn btn-white text-lg text-center order-1 order-md-12"

    if (page + 1 == numPage) {
      style += " disabled"
    }

    return style
  }

  getPageBtns = (page, numPage) => {
    const { contentMap } = this.props

    const params = Utils.ParseURLQuery(this.getSearch())
    const pageBtns = []

    let startPage = 0

    if (page > 2) {
      if (page > numPage - 3) {
        startPage = numPage - 5
      } else {
        startPage = page - 2
      }
    }

    pageBtns.push(
      <Link
        to={this.getPageLinkPath(params, 0, numPage)}
        title={contentMap.page_first.value}
        key="start"
        className={this.getPrevStyle(page)}
        onClick={e => this.goToPage(e, 0)}
        state={{ ts_value: params["ts"] }}
      >
        {"<<"}
      </Link>,
      <Link
        to={this.getPageLinkPath(params, page - 1, numPage)}
        title={contentMap.page_previous.value}
        key="previous"
        className={this.getPrevStyle(page)}
        onClick={e => this.goToPage(e, page - 1)}
        state={{ ts_value: params["ts"] }}
      >
        {"<"}
      </Link>
    )

    for (let i = 0; i < numPage; i++) {
      const visible = i >= startPage && i < startPage + 5
      const btnStyle =
        "col-2 col-md-1 btn text-lg text-center order-2" +
        (i === page ? " btn-dark disabled" : " btn-white")

      pageBtns.push(
        <Link
          to={this.getPageLinkPath(params, i, numPage)}
          title={contentMap.page_number.value + " " + (i + 1)}
          key={i}
          className={visible ? btnStyle : "d-none"}
          onClick={e => this.goToPage(e, i)}
          state={{ ts_value: params["ts"] }}
        >
          {i + 1}
        </Link>
      )
    }

    pageBtns.push(
      <Link
        to={this.getPageLinkPath(params, page + 1, numPage)}
        title={contentMap.page_next.value}
        key="next"
        className={this.getNextStyle(page, numPage)}
        onClick={e => this.goToPage(e, page + 1)}
        state={{ ts_value: params["ts"] }}
      >
        {">"}
      </Link>,
      <Link
        to={this.getPageLinkPath(params, numPage - 1, numPage)}
        title={contentMap.page_last.value}
        key="end"
        className={this.getNextStyle(page, numPage)}
        onClick={e => this.goToPage(e, numPage - 1)}
        state={{ ts_value: params["ts"] }}
      >
        {">>"}
      </Link>
    )

    return pageBtns
  }

  getPageLinkPath(params, page, numPage) {
    const { breadCrumb, language } = this.props

    if (page >= 0 && page < numPage) {
      params.page = page
    }

    return Utils.GetLanguageLink(
      language,
      "/" + breadCrumb + "/" + Utils.CreateURLQuery(params)
    )
  }

  getPageLinks = () => {
    const page = this.getPage()
    const numPage = this.getNumPage()

    if (numPage < 2) {
      return
    }

    return (
      <div className="row justify-content-center mb-4">
        {this.getPageBtns(page, numPage)}
      </div>
    )
  }

  render() {
    return (
      <div className="col-xl-9 col-lg-8 order-lg-2">
        <div className="row">{this.getProducts()}</div>
        {this.getPageLinks()}
      </div>
    )
  }
}
